import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MemoComponent } from './memo.component';
import { MaterialsModule } from '../../modules/material.module';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { InputBoxModule } from '../input-box/input-box.module';
import { FormFieldsModule } from '../form-fields/form-fields.module';

@NgModule({
  declarations: [MemoComponent],
  imports: [CommonModule, FormsModule, MaterialsModule, InputBoxModule, TranslateModule.forChild(), FormFieldsModule],
  exports: [MemoComponent],
})
export class MemoModule {}
